var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":""},on:{"click":_vm.openNewPipelineDialog}},[_vm._v(" New Pipeline ")])
}
var staticRenderFns = []

export { render, staticRenderFns }